import React from "react";

const Breadcrumb = ({ path, onClick }) => {
  const pathSegments = path.split("/");

  return (
    <nav className="flex items-center space-x-2 text-sm text-gray-600">
      {pathSegments.map((segment, index) => {
        const currentPath = pathSegments.slice(0, index + 1).join("/");
        const isLast = index === pathSegments.length - 1;

        return (
          <div key={currentPath} className="flex items-center">
            <button
              className={`${
                isLast
                  ? "text-blue-600 font-semibold cursor-default"
                  : "text-gray-500 hover:underline"
              }`}
              onClick={() => !isLast && onClick(currentPath)}
              disabled={isLast}
            >
              {segment || "Home"}
            </button> 
            {!isLast && <span className="mx-1">/</span>}
          </div>
        );
      })}
    </nav>
  );
};

export default Breadcrumb;
